import api from "./api";

export async function getCategoryConfigs() {
  const res = await api.get("/api/warehouse/category-configs");
  return res.data?.category_configs || [];
}
export async function updateCategoryConfig(id, payload) {
  const res = await api.put(`/api/warehouse/category-configs/${id}`, payload);
  return res.data?.category_config;
}

// Real categories come from Smart Scan's own classification (l3_category) per item.
export async function getScanCategories() {
  const res = await api.get("/api/warehouse/scan-categories");
  return res.data?.categories || [];
}

// Smart Scan categories -> one of the 8 generic storage buckets
export async function getCategoryBucketMap() {
  const res = await api.get("/api/warehouse/category-bucket-map");
  return res.data?.mappings || [];
}
export async function setCategoryBucketMap(category_name, bucket_key) {
  const res = await api.post("/api/warehouse/category-bucket-map", { category_name, bucket_key });
  return res.data;
}

export async function getLocations(params = {}) {
  const res = await api.get("/api/warehouse/locations", { params });
  return res.data?.locations || [];
}
export async function createLocation(payload) {
  const res = await api.post("/api/warehouse/locations", payload);
  return res.data?.location;
}
export async function getGridSummary(warehouse_id) {
  const res = await api.get("/api/warehouse/grid-summary", { params: { warehouse_id } });
  return res.data?.grids || [];
}
export async function bulkUpdateGrid(payload) {
  const res = await api.put("/api/warehouse/grid", payload);
  return res.data;
}
export async function bulkDeleteGrid(payload) {
  const res = await api.delete("/api/warehouse/grid", { data: payload });
  return res.data;
}
export async function bulkGenerateLocations(payload) {
  const res = await api.post("/api/warehouse/locations/bulk-generate", payload);
  return res.data;
}
